import { useEffect, useState } from "react";
import { Phone } from "lucide-react";

export default function StickyCTA() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 800);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="tel:+19058222690"
      data-testid="sticky-call-cta"
      className={`lg:hidden fixed bottom-5 right-4 z-40 bg-ink-900 text-sand-50 px-5 py-4 flex items-center gap-2 shadow-2xl shadow-black/30 hover:bg-gold transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <Phone className="w-4 h-4" />
      <span className="text-xs tracking-[0.15em] uppercase font-medium">Call Now</span>
    </a>
  );
}
